module.exports = __webpack_public_path__ + "img/selected3-min.966ad912.png";